import { Component, TemplateRef } from '@angular/core';

import { Router } from '@angular/router';
import { ConfirmOperationComponent } from '../../../@theme/components/confirm-operation/confirm-operation.component';
import { NbDialogService, NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { EHSService } from './ehs-micro-indicador.service';
import { MyCustomImportEHSComponent } from './custom-action-ehs-import';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'ngx-ehs-micro-indicador',
  templateUrl: './ehs-micro-indicador.component.html',
  styleUrls: ['./ehs-micro-indicador.component.scss'],
})
export class EhsMicroIndicadorComponent {

  public healthScores = [];
  date;
  objRecalc: any = {};
  bsValue = new Date();
  runningCalc = false;

  settings = {
    actions: {
      columnTitle: 'Ações',
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
    },
    mode: 'external',
    columns: {
      name: {
        title: 'Nome',
        type: 'string',
      },
      entity: {
        title: 'Origem',
        type: 'string',
        valuePrepareFunction: (value) => {
          let desc;

          switch (value) {
            case 'FEEDBACK':
              desc = 'Feedback'
              break;
            case 'INTERNAL_SEARCH':
              desc = 'Pesquisa interna'
              break;
            case 'EXTERNAL':
              desc = 'Externa';
              break;
            default:
              desc = '-'
              break;
          }
          return desc;
        }
      },
      customColumn: {
        title: '',
        type: 'custom',
        width: '8%',
        filter: false,
        renderComponent: MyCustomImportEHSComponent,
        onComponentInitFunction: (instance) => {
          instance.save.subscribe(row => {
            switch (row.context) {
              case 'DASHBOARD':
                this.router.navigate(['pages/admin/ehs-micro-indicador/import', row.id]);
                break;
              default:
                break;
            }

          });
        },
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  constructor(private router: Router, private dialogService: NbDialogService,
    private ehsService: EHSService,
    private localeService: BsLocaleService,
    private toastrService: NbToastrService) {
    this.localeService.use('pt-br');
    this.getAll();

    this.bsValue.setDate(this.bsValue.getDate() - 1);
  }

  public peridoInvalid = false;

  modelChanged(event, tab) {
    tab.dateFinishSelected = event;
    const diffInMs = new Date(tab.dateInitSelected).getTime() - new Date(tab.dateFinishSelected).getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    const positiveDays = - diffInDays;
    if (positiveDays > 31) {
      this.peridoInvalid = true;
    } else {
      this.peridoInvalid = false;
    }
  }

  modelChangedInit(event, tab) {
    tab.dateInitSelected = event;
  }

  getAll() {
    this.ehsService.query().toPromise().then(result => {
      this.healthScores = result.body;
    })
  }

  open(dialog: TemplateRef<any>) {
    this.objRecalc = {};
    this.dialogService.open(dialog, { closeOnBackdropClick: false, context: 'this is some additional data passed to dialog' });
  }

  openCreateDialog() {
    this.router.navigate(['pages/admin/ehs-micro-indicador', 'create']);
  }

  openEditDialog(event): void {
    this.router.navigate(['pages/admin/ehs-micro-indicador', event.data.id]);
  }

  runManual() {
    this.ehsService.runManual(this.date).toPromise().then(result => {
      this.toastrService.show('EHS', 'SUCESSO',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
    });
  }

  convertDate(tab) {
    if (tab.init) {
      const datestring = tab.init.getDate() + '/' + (tab.init.getMonth() + 1) + '/'
        + tab.init.getFullYear();
      tab.init = datestring;
    }

    if (tab.end) {
      const datestring = tab.end.getDate() + '/' + (tab.end.getMonth() + 1) + '/'
        + tab.end.getFullYear();
      tab.end = datestring;
    }
  }

  valid(obj) {
    if (!obj.init) {
      this.validErrorMessage('Preecha o campo início');
      return false;
    }
    if (!obj.end) {
      this.validErrorMessage('Preecha o campo fim');
      return false;
    }
    return true;
  }

  validErrorMessage(message) {
    this.toastrService.show('Importação', message,
      { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
  }

  recalcSave(obj, ref) {
    if (!this.valid(obj)) {
      return;
    }
    this.runningCalc = true;
    this.convertDate(obj);
    this.ehsService.runManualRange(obj).toPromise().then(result => {
      this.toastrService.show('EHS', 'Recálculo executado com sucesso!',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.runningCalc = false;
      ref.close();
    }).catch(err => {
      this.toastrService.show('EHS', 'Erro ao recalcular',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
      this.runningCalc = false;
      this.objRecalc = {};
    });

  }

  onDeleteConfirm(event): void {
    this.dialogService.open(ConfirmOperationComponent, {
      context: {
        title: 'Excluir microindicador',
        text: `Você realmente deseja excluir o microindicador ${event.data.name}?`,
        accent: 'danger',
      },
    }).onClose.subscribe(response => response.confirmed && this.delete(event.data.id));
  }

  delete(id) {
    this.ehsService.delete(id).toPromise().then(response => {
      this.toastrService.show('Microindicador', 'Excluído com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.getAll();
    }).catch(err => {
      this.toastrService.show('Microindicador', err.error.title,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }
}
